<template>
    <span class="preset-key"><slot></slot></span>
</template>
<style>
.preset-key {
  display: inline-block;
    background: #000;           /* black background */
    color: #fff;                /* white text */
    border-radius: 4px;         /* slightly rounded corners */
    padding: 2px 6px;           /* some inner space */
    margin: 0 2px;              /* small space between keys */
    font-family: monospace;     /* classic keyboard feel */
    font-size: 0.9em;           /* optional: slightly smaller */
    border: 1px solid #555;     /* subtle border for 3D look */
    box-shadow: 0 2px 0 #333;   /* slight shadow for depth */
}
</style>